<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div v-if="formOpen">
        <estoqueForm
          ref="estoqueForm"
          :estoque="estoque"
          :salvar="salvar"
          :set-loading="setLoading"
        />
        <!-- :is-updating="isUpdating" -->
      </div>
      <div v-else>
        <div class="col-md-8">
          <b-form-group id="input-group-1" label="Pesquisar" label-for="filter">
            <b-input-group>
              <b-form-input
                id="filter"
                v-model="insumoSearch"
                type="text"
                placeholder="Pesquise por nome ou código"
                @keydown.enter.prevent="
                  insumoSearch &&
                  insumoSearch.length >= 1 &&
                  isNaN(Number(insumoSearch))
                    ? buscaInsumoNome()
                    : insumoSearch &&
                      insumoSearch.length >= 1 &&
                      !isNaN(Number(insumoSearch))
                    ? buscaInsumoCodigo()
                    : listaEstoque()
                "
              ></b-form-input>
              <b-input-group-append
                v-if="isNaN(Number(insumoSearch)) && insumoSearch.length >= 1"
              >
                <b-button @click="buscaInsumoNome">Pesquisar Nome</b-button>
              </b-input-group-append>
              <b-input-group-append
                v-else-if="
                  !isNaN(Number(insumoSearch)) && insumoSearch.length >= 1
                "
              >
                <b-button @click="buscaInsumoCodigo">Pesquisar Código</b-button>
              </b-input-group-append>
              <b-input-group-append v-else>
                <b-button @click="listaEstoque()">Buscar Todos</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <Table
          :key="keyTable"
          :carregando="carregando"
          :search="false"
          :form-open="formOpen"
          :tables-fields="hasPermission ? grupoFields : grupoFieldsNoAction"
          :table-items="estoques"
          :excel-columns="excelColumns"
          :excel-fields="excelList"
          :count-rows="rows"
          :page="0"
          :no-action="hasPermission ? false : true"
          @onEdit="edit"
          @onDelete="deleteEstoque"
          @onPaginate="listaEstoque"
        >
          <template v-slot:cell(obra)="row">
            <span
              v-b-tooltip.hover
              title="ver unidades convertidas"
              class="text-hover"
              @click="verUnidadesConvertidas(row.item.obra._id)"
            > 
              {{ row.item.obra.nome }}
            </span>
          </template>
          <template v-slot:cell(qtde)="row">
            <b-form-input
              v-model="row.item.qtde"
              type="number"
              :disabled="row.item.disableFields"
            />
          </template>
          <template v-slot:cell(unit)="row">
            <b-form-select
              :value="row.item.insumo.unidade"
              :disabled="row.item.disableFields"
              @change="changeUnitFromRawMaterial($event, row.item)"
            >
              <b-form-select-option
                v-for="unit in units"
                :key="unit._id"
                :value="unit.nome"
                :disabled="row.item.disableFields"
              >
                {{ unit.nome }}
              </b-form-select-option>
            </b-form-select>
          </template>
          <template v-slot:cell(lowStock)="row">
            <b-form-input
              v-model="row.item.insumo.estoqueBaixo"
              type="number"
              :disabled="row.item.disableFields"
            />
          </template>
          <template v-slot:cell(valor_unitario)="row">
            <b-form-input
              v-model="row.item.valor_unitario"
              :disabled="row.item.disableFields"
            />
          </template>
          <template v-slot:cell(alertaEstoque)="row">
            <b-badge
              v-if="row.item.alertaEstoque === true"
              variant="danger"
              class="pl-2 pr-2 pt-1 pb-1"
              >Estoque baixo</b-badge
            >
          </template>
          <template v-slot:cell(estoqueInsumo)="row">
            {{ row.item.insumo ? row.item.insumo.codigo : '' }} -
            <span
              v-if="row.item.insumo.descricao_pai || row.item.descricao_pai"
            >
              {{
                row.item.insumo.descricao_pai
                  ? row.item.insumo.descricao_pai
                  : row.item.descricao_pai
              }}
              <br />
            </span>
            {{ row.item.insumo ? row.item.insumo.descricao : '' }}
          </template>
        </Table>
        <!-- Exibe as conversões do estoque da obra selecionada -->
        <b-modal
          id="modal-conversoes"
          title="Unidades convertidas"
          ok-title="Fechar"
          ok-variant="white"
          ok-only
          size="xl"
          @show="conversoesItens = []"
        >
          <b-form-group class="mb-3">
            <b-form-checkbox v-model="listaPequena" inline>
              lista pequena
            </b-form-checkbox>
            <b-form-checkbox v-model="listras" inline>
              listras
            </b-form-checkbox>
          </b-form-group>
          <b-table
            :items="conversoesItens"
            :fields="conversoesFields"
            :busy="modalConversoesLoading"
            :small="listaPequena"
            :striped="listras"
            responsive
            class="border p-3 rounded custom-min-height"
          >
            <template v-slot:table-busy>
              <div class="text-center">
                <strong>carregando...</strong>
              </div>
            </template>
            <template v-slot:cell(codigo)="row">
              <span>
                {{
                  row.item.codigo.$numberDecimal ?
                  row.item.codigo.$numberDecimal :
                  row.item.codigo
                }}
              </span>
            </template>
            <template v-slot:cell(unidadeConvertida)="row">
              <span 
                v-if="row.item.unidadeConvertida"
                class="emphasis-text"
              >
                {{ row.item.unidadeConvertida }}
              </span>
              <span v-else class="transparent-text">não convertido</span>
            </template>
            <template v-slot:cell(qtdeConvertida)="row">
              <span 
                v-if="row.item.qtdeConvertida"
                class="emphasis-text"
              >
                {{ row.item.qtdeConvertida }}
              </span>
              <span v-else class="transparent-text">0</span>
            </template>

          </b-table>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import estoqueForm from '@/src/components/forms/controleObra/estoqueForm.vue'
import Table from '@/src/components/tables/table-register.vue'
import serviceEstoqueObra from '@/src/services/serviceEstoqueObra'
import UnitService from '@/src/services/unidadesObras'
import alertMixin from '@/src/mixins/alertMixin'
import user from '@/src/services/user'

export default {
  components: { Layout, HeaderPage, estoqueForm, Table },
  mixins: [alertMixin],
  data() {
    return {
      listaPequena: false,
      listras: false,
      modalConversoesLoading: false,
      conversoesItens: [],
      conversoesFields: [
        { key: 'obra', label: 'Obra'},
        { key: 'codigo', label: 'Código' },
        { key: 'insumo', label: 'Insumo' },
        { key: 'unidadePadrao', label: 'Unid. Padrão' },
        { key: 'qtde', label: 'Quantidade. Padrão' },
        { key: 'unidadeConvertida', label: 'Unid. Convertida' },
        { key: 'qtdeConvertida', label: 'Quant. Convertida' },
      ],
      excelList: [],
      hasPermission: false,
      userCurrent: {},
      keyTable: 0,
      carregando: false,
      insumoSearch: '',
      isLoading: false,
      pageTitles: {
        title: 'Estoques',
        subtitle: 'Cadastro de Estoque',
      },
      formOpen: false,
      grupoFields: [
        {
          key: 'obra',
          label: ' Obra',
          class: 'size-col-20',
        },
        {
          key: 'estoqueInsumo',
          label: ' Cod. | Insumo',
          class: 'size-col-40',
        },
        {
          key: 'qtde',
          label: 'Quantidade',
          class: 'size-col-20',
        },
        {
          key: 'unit',
          label: 'Unid.',
          class: 'size-col-20',
        },
        {
          key: 'lowStock',
          label: 'Estoque mínimo',
          class: 'size-col-20',
        },
        {
          key: 'valor_unitario',
          label: 'Valor Unitário',
          class: 'size-col-20',
        },
        {
          key: 'valor_total',
          label: 'Valor Total',
          class: 'size-col-20',
        },
        {
          key: 'alertaEstoque',
          label: '',
          class: 'size-col-20',
        },
        {
          key: 'actions',
          label: '',
          class: 'size-col-10',
        },
      ],
      grupoFieldsNoAction: [
        {
          key: 'obra',
          label: ' Obra',
          class: 'size-col-20',
        },
        {
          key: 'estoqueInsumo',
          label: ' Cod. | Insumo',
          class: 'size-col-40',
        },
        {
          key: 'qtde',
          label: 'Quantidade',
          class: 'size-col-20',
        },
        {
          key: 'unit',
          label: 'Unid.',
          class: 'size-col-20',
        },
        {
          key: 'lowStock',
          label: 'Estoque mínimo',
          class: 'size-col-20',
        },
        {
          key: 'valor_unitario',
          label: 'Valor Unitário',
          class: 'size-col-20',
        },
        {
          key: 'valor_total',
          label: 'Valor Total',
          class: 'size-col-20',
        },
        {
          key: 'alertaEstoque',
          label: '',
          class: 'size-col-20',
        },
      ],
      // isUpdating: false,
      estoque: { insumo: {} },
      estoques: [],
      units: [],
      rows: 0,
    }
  },
  async created() {
    await Promise.all([
      this.listaEstoque(0),
      this.getAllUnits(),
      this.userPermissionFirst(),
    ])
  },
  mounted() {
    //this.listaEstoqueExcel()
  },
  methods: {
    async verUnidadesConvertidas(obraId) {
      this.$bvModal.show('modal-conversoes')
      this.modalConversoesLoading = true;
      try {
        const {data:{data}} = await serviceEstoqueObra
          .encontraEstoquePeloIdDaObra(obraId);
        this.conversoesItens = data;
      } catch (error) {
        console.error(error.response.data.error.message);
        this.makeToast(`${error.response.data.error.message}`, 'warning')
      } finally {
        this.modalConversoesLoading = false;
      }
    },

    changeUnitFromRawMaterial(unit, stock) {
      stock.insumo.unidade = unit
    },
    handlerFocus(item) {
      const unitaryValue = item.valor_unitario

      if (unitaryValue) {
        const removedSpace = unitaryValue.replace(' ', '')
        const removedComma = removedSpace.replace(',', '.')
        const removedRealSymbol = removedComma.replace('R$', '')
        const unitaryValueNumber = Number(removedRealSymbol)
        const total = unitaryValueNumber * Number(item.qtde)

        item.valor_total = `R$ ${total}`
      }
    },
    async userPermissionFirst() {
      const userInfo = this.$store.state.auth.currentUser.user
      this.userCurrent = {}
      await user.listById(userInfo._id).then((res) => {
        this.userCurrent = res.data.data
        this.keyTable++
        this.userPermissions()
      }).catch((err) => {
        console.error(err)

        this.errorMessage('Erro ao carregar permissões do usuário')
      })
    },
    async userPermissions() {
      if (this.userCurrent.tipo_conta === undefined) {
        setTimeout(() => {
          this.userPermissions()
        }, 5000)
        return
      }
      if (
        this.userCurrent.tipo_conta === 'master' ||
        this.userCurrent.tipo_conta === 'engenheiro' ||
        this.userCurrent.tipo_conta === 'administrador'
      ) {
        this.hasPermission = true
      }
      
      this.hasPermission = this.userCurrent.permissoes.some((item) => item === 'estoque_edicao')
      this.keyTable++
    },
    async getAllUnits() {
      const {
        data: { data },
      } = await UnitService.list()

      this.units = data
    },

    // updateByFiliais() {
    //   this.listaEstoque()
    //   this.listaEstoqueExcel()
    //   if (this.formOpen) {
    //     this.$refs.estoqueForm.listaObra()
    //   }
    // },

    setLoading(loading) {
      this.isLoading = loading
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.estoque = {}
      // this.isUpdating = false
      if (!this.formOpen) {
        this.listaEstoque(0)
      }
    },
    listaEstoque(currentPage = 0) {
      if (this.estoques.length <= 10 || this.insumoSearch === '') {
        this.isLoading = true

        serviceEstoqueObra
          .list(
            currentPage,
            10,
            this.$store.state.filter,
            this.$store.state.filial
          )
          .then((res) => {
            const data = res.data.data

            this.estoques = data.results.map((stock) => {
              if (stock) {
                stock['disableFields'] = true
                return stock
              }
            })

            this.estoques = this.estoques.filter((stock, index) => {
              return stock !== undefined
            })

            this.rows =
              data.count > 10 ? data.count : data.results.length
          })
          .catch((_error) => {
            this.errorMessage(`Erro ao listar o estoque`)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    formatValue() {
      let formattedValue = this.estoque.valor_unitario
      formattedValue = formattedValue.replace('R$', '')
      formattedValue = formattedValue.replace('.', '')
      formattedValue = formattedValue.replace(',', '.')
      formattedValue = formattedValue.trim()

      return formattedValue
    },
    listaEstoqueExcel() {
      this.carregando = true
      serviceEstoqueObra
        .list(
          0,
          999999999999999,
          this.$store.state.filter,
          this.$store.state.filial
        )
        .then((res) => {
          const data = res.data
          const results = data.results
          if (results && results.length > 0) {
            for (const estoque of results) {
              if (estoque) {
                var dataEstoque = {
                  valor_total: estoque.valor_total,
                  valor_unitario: estoque.valor_unitario,
                  codigo: `${estoque.insumo.codigo}`,
                  insumo: `${
                    estoque.insumo.descricao_pai === undefined
                      ? ''
                      : estoque.insumo.descricao_pai
                  }${
                    estoque.insumo.descricao_pai === undefined
                      ? estoque.insumo.descricao
                      : ' / ' + estoque.insumo.descricao
                  }`,
                  subitem: `${
                    estoque.insumo.descricao_pai === undefined
                      ? ''
                      : estoque.insumo.descricao
                  }`,
                  qtde: estoque.qtde,
                  alerta: estoque.alertaEstoque
                    ? 'Estoque baixo'
                    : 'Tem estoque',
                  unidade: estoque.insumo.unidade,
                }
                this.excelList.push(dataEstoque)
              }
            }
          }
          this.carregando = false
        })
    },
    async salvar() {
      this.setLoading(true)
      try {
        if (this.estoque.insumo.subItens) {
          this.estoque.insumo.subItens.splice(
            this.estoque.insumo.subItens.findIndex(
              (e) => e.codigo === this.estoque.insumo.codigo
            ),
            1
          )
        }

        const unitaryValue = this.formatValue()

        if (this.estoque._id) {
          await serviceEstoqueObra.update(this.estoque._id, {
            ...this.estoque,
            valor_unitario: unitaryValue,
          })

          this.successMessage('Atualizado com sucesso')
        } else {
          await serviceEstoqueObra.create({
            ...this.estoque,
            tipo: 'entrada',
            valor_unitario: unitaryValue,
          })
          this.abrirForm()
          this.successMessage('Salvo com sucesso')
        }

        this.listaEstoque()
        this.estoque = {}
      } catch (error) {
        console.error(error)
        this.errorMessage(error.response.message)
      } finally {
        this.setLoading(false)
      }
    },
    async edit(stock) {
      this.estoque = stock
      // this.isUpdating = true

      if (stock.disableFields) {
        stock.disableFields = false

        return
      }

      const unitaryValue = this.estoque.valor_unitario

      if (unitaryValue) {
        const removedSpace = unitaryValue.replace(' ', '')
        const removedComma = removedSpace.replace(',', '.')
        const removedRealSymbol = removedComma.replace('R$', '')
        const unitaryValueNumber = Number(removedRealSymbol)
        const total = unitaryValueNumber * Number(this.estoque.qtde)

        const formattedTotal = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(total);

        this.estoque.valor_total = formattedTotal
      }

      await this.salvar()
    },
    async deleteEstoque(id) {
      try {
        this.isLoading = true
        await serviceEstoqueObra.remove(id)
        this.listaEstoque()
        this.estoque = {}
        this.isLoading = false
        this.successMessage('Deletado com sucesso')
      } catch (error) {
        this.errorMessage('Erro ao Deletar Estoque')
      }
    },
    async buscaInsumoCodigo() {
      try {
        this.isLoading = true
        let { data } = await serviceEstoqueObra.buscaCodigo(
          String(this.insumoSearch).trim(),
          this.$store.state.filter,
          this.$store.state.filial
        )

        if (!data || data.length === 0) {
          this.errorMessage('Insumo não Encontrado')
        } else {
          data = data.data
          this.estoques = data.results

          this.rows = data.count
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.errorMessage(
          error.response.data.message !== undefined
            ? error.response.data.message
            : 'Não foi possível encontrar o insumo'
        )
      }
    },
    async buscaInsumoNome() {
      try {
        this.isLoading = true
        let data = null

        if (this.$store.state.filial) {
          data = await serviceEstoqueObra.buscaNome(
            this.insumoSearch,
            false,
            true,
            this.$store.state.filial
          )
        } else {
          data = await serviceEstoqueObra.buscaNome(
            this.insumoSearch,
            false,
            true,
            false
          )
        }
        if (!data || data.length === 0) {
          this.errorMessage('Insumo não Encontrado')
          return
        }
        data = data.data

        let results = data.data.results
        let count = data.data.count
        this.estoques = results
        this.rows = count
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.error(error.response.data.message)
        this.errorMessage(
          error.response.data.message !== undefined
            ? error.response.data.message
            : 'Não foi possível encontrar o insumo'
        )
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
